/**
 * Start/End Node Component - Pink diamond-shaped node
 * Matches Figma design with rotated square and arrow icons
 */

import React from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { ArrowRightIcon, ArrowRightBarIcon } from '../../../../components/Icons';
import './graphNodes.css';

interface StartEndNodeData {
  label: string;
  isStart?: boolean;
}

const StartEndNode: React.FC<NodeProps<StartEndNodeData>> = ({ data }) => {
  const isStart = data.isStart ?? data.label.toUpperCase() === 'START';

  return (
    <div className="workflow-node workflow-node--start-end">
      {/* LEFT: target="left", source="left-source" */}
      <Handle type="target" position={Position.Left} id="left" className="workflow-node__handle" />
      <Handle type="source" position={Position.Left} id="left-source" className="workflow-node__handle" />

      {/* RIGHT: source="right", target="right-target" */}
      <Handle type="source" position={Position.Right} id="right" className="workflow-node__handle" />
      <Handle type="target" position={Position.Right} id="right-target" className="workflow-node__handle" />

      {/* TOP: target="top", source="top-source" */}
      <Handle type="target" position={Position.Top} id="top" className="workflow-node__handle" />
      <Handle type="source" position={Position.Top} id="top-source" className="workflow-node__handle" />

      {/* BOTTOM: source="bottom", target="bottom-target" */}
      <Handle type="source" position={Position.Bottom} id="bottom" className="workflow-node__handle" />
      <Handle type="target" position={Position.Bottom} id="bottom-target" className="workflow-node__handle" />
  
      <div className="workflow-node__container">
        {isStart ? (
          <ArrowRightIcon className="workflow-node__icon" />
        ) : (
          <ArrowRightBarIcon className="workflow-node__icon" />
        )}
      </div>
      
      <div className="workflow-node__label">{data.label}</div>
    </div>
  );
};

export default StartEndNode;
